export default "__VITE_ASSET__Crsc2qg___"